var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIonicIosEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.003,
    height: 12.862,
    viewBox: "0 0 15.003 12.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-eye-off",
    "data-name": "Icon ionic-ios-eye-off",
    transform: "translate(-2.252 -4.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10464",
    "data-name": "Path 10464",
    d: "M5.317,4.637a.476.476,0,0,0-.673.673L16.55,17.224a.472.472,0,0,0,.459.121.464.464,0,0,0,.214-.124.475.475,0,0,0,0-.67Z",
    transform: "translate(-1.18)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16277",
    "data-name": "Group 16277",
    transform: "translate(2.252 6.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10465",
    "data-name": "Path 10465",
    d: "M9.894,17.624a3.011,3.011,0,0,1-2.864-4.3L5.242,11.531a23.494,23.494,0,0,0-2.85,2.723.53.53,0,0,0,0,.713c2.174,2.4,4.09,4.468,7.358,4.468a6.449,6.449,0,0,0,2.756-.643l-1.457-1.457A3.043,3.043,0,0,1,9.894,17.624Z",
    transform: "translate(-2.252 -9.79)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10466",
    "data-name": "Path 10466",
    d: "M22.335,13.033a.525.525,0,0,0,.017-.693c-1.752-2.127-4.18-4.465-7.385-4.465a6.27,6.27,0,0,0-2.746.636l1.464,1.464a2.951,2.951,0,0,1,1.149-.288,3.011,3.011,0,0,1,2.864,4.3l1.792,1.792A22.155,22.155,0,0,0,22.335,13.033Z",
    transform: "translate(-7.472 -7.875)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10467",
    "data-name": "Path 10467",
    d: "M13.507,17.479a2.152,2.152,0,0,0,1.973,1.973,2.094,2.094,0,0,0,.784-.087l-2.673-2.673A2.191,2.191,0,0,0,13.507,17.479Z",
    transform: "translate(-8.143 -12.492)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10468",
    "data-name": "Path 10468",
    d: "M21.712,17.856c0-.044,0-.087,0-.131a1.485,1.485,0,0,1-.61.131c-.037,0-.07,0-.1,0l.623.626A2.142,2.142,0,0,0,21.712,17.856Z",
    transform: "translate(-12.067 -13.033)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10469",
    "data-name": "Path 10469",
    d: "M17.319,14.069a1.574,1.574,0,0,1,.1-.566c-.033,0-.067,0-.1,0a2.119,2.119,0,0,0-.62.094l.626.626C17.322,14.17,17.319,14.12,17.319,14.069Z",
    transform: "translate(-9.817 -10.821)",
    fill: "#0267c1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIonicIosEyeOff);
export default __webpack_public_path__ + "static/media/Icon_ionic_ios_eye_off.53cf5d70ea5e9d5a41f0e52ebc2df3be.svg";
export { ForwardRef as ReactComponent };